import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import Footer from '../components/Footer';
import staticlogo from '../assets/images/bg_blue.svg';
import helpcenterimage from '../assets/images/logo_icon_white.svg';
import looking_help from '../assets/images/help-main-page-img-new.svg';
import config from '../config/config';

const Help = () => {
  const navigate = useNavigate();
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const [metaKeywords, setMetaKeywords] = useState('');
  const [helpData, setHelpData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

 useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await fetch(`${config.baseURL}/get-help-page-content`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const result = await response.json();
      if (result.success) {
        const mainCategories = result.data['main-categories'] || [];
        const parentCategories = result.data['parent-categories'] || [];
        const childCategories = result.data['child-categories'] || [];
        const pageSEO = result.data['page-seo'] || {};

        // Set the SEO meta tags from the API response
        setMetaTitle(pageSEO.meta_title || 'Default Title');
        setMetaDescription(pageSEO.meta_description || '');
        setMetaKeywords(pageSEO.meta_keywords || '');

        setHelpData({
          mainCategories,
          parentCategories,
          childCategories,
          pageSEO,
        });
      } else {
        console.error('Error in response:', result);
      }
    } catch (error) {
      console.error('Error fetching help data:', error);
    }
  };

  fetchData();
}, []);



  useEffect(() => {
    // Update document head with SEO metadata
    document.title = metaTitle || 'Default Title';
    const metaDescriptionTag = document.querySelector('meta[name="description"]');
    const metaKeywordsTag = document.querySelector('meta[name="keywords"]');

    // Update or create meta description tag
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute('content', metaDescription || '');
    } else {
      const newMetaDescriptionTag = document.createElement('meta');
      newMetaDescriptionTag.name = 'description';
      newMetaDescriptionTag.content = metaDescription || '';
      document.head.appendChild(newMetaDescriptionTag);
    }

    // Update or create meta keywords tag
    if (metaKeywordsTag) {
      metaKeywordsTag.setAttribute('content', metaKeywords || '');
    } else {
      const newMetaKeywordsTag = document.createElement('meta');
      newMetaKeywordsTag.name = 'keywords';
      newMetaKeywordsTag.content = metaKeywords || '';
      document.head.appendChild(newMetaKeywordsTag);
    }
  }, [metaTitle, metaDescription, metaKeywords]);


  // Function to handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

// Function to filter help content based on search query
const filterHelpData = () => {
  if (!searchQuery) return helpData;

  const lowerCaseQuery = searchQuery.toLowerCase();

  // Filter main categories
  const filteredMainCategories = helpData.mainCategories.filter(category =>
    category.title.toLowerCase().includes(lowerCaseQuery)
  );

  // Filter parent categories based on the search query and its relation to child categories
  const filteredParentCategories = helpData.parentCategories.filter(parent =>
    parent.title.toLowerCase().includes(lowerCaseQuery) || 
    helpData.childCategories.some(child => 
      child['parent-category-id'] === parent.id && child.title.toLowerCase().includes(lowerCaseQuery)
    )
  );

  // Filter child categories based on the search query and their related parent categories
  const filteredChildCategories = helpData.childCategories.filter(child =>
    child.title.toLowerCase().includes(lowerCaseQuery) ||
    filteredParentCategories.some(parent => child['parent-category-id'] === parent.id)
  );

  // Compile the filtered data
  return {
    mainCategories: filteredMainCategories,
    parentCategories: filteredParentCategories,
    childCategories: filteredChildCategories
  };
};

const filteredHelpData = filterHelpData();

return (
    <div>

      <div className="static_header_inner">
        <div className="container-fluid">
          <div className="col-md-12">
            <div className="static_header_logo">
              <Link to="/help">
                <img src={staticlogo} alt="Logo" /> Community Guidelines
              </Link>

              <div className="search_btn_after_scroll hidden">
                <button
                  className="create_post_btn_area verify_btn search_btn_chat"
                  id="help_search_btn"
                >
                  <svg
                    className="heading_search_icon"
                    id="search_icon"
                    width={38}
                    height={38}
                    viewBox="0 0 38 38"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30.9109 17.3353C30.9109 24.7219 24.8843 30.7294 17.426 30.7294C9.96774 30.7294 3.94118 24.7219 3.94118 17.3353C3.94118 9.94871 9.96774 3.94118 17.426 3.94118C24.8843 3.94118 30.9109 9.94871 30.9109 17.3353Z"
                      stroke="#fff"
                      strokeWidth="3.88235"
                    />
                    <path
                      d="M33.6317 36.3769C34.392 37.1327 35.6211 37.1291 36.3769 36.3688C37.1327 35.6085 37.1291 34.3794 36.3688 33.6236L33.6317 36.3769ZM36.3688 33.6236L29.144 26.4412L26.4068 29.1945L33.6317 36.3769L36.3688 33.6236Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <section id="help_search" className="help_search">
        <div className="help_bg_image" />
          <div className="container">
            <div className="row">
              <div className="help_search_block">
                <h2 className="help_title">Hi, how can we help?</h2>
                <form className="help_search_form" onSubmit={(e) => e.preventDefault()}>
                <input
                  type="search"
                  maxLength={100}
                  spellCheck="false"
                  autoCorrect="off"
                  autoComplete="off"
                  autoCapitalize="off"
                  placeholder="Search"
                  className="form-control"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <button className="help_search_form_btn">
                  <svg
                    width={38}
                    height={38}
                    viewBox="0 0 38 38"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30.9109 17.3353C30.9109 24.7219 24.8843 30.7294 17.426 30.7294C9.96774 30.7294 3.94118 24.7219 3.94118 17.3353C3.94118 9.94871 9.96774 3.94118 17.426 3.94118C24.8843 3.94118 30.9109 9.94871 30.9109 17.3353Z"
                      stroke="#fff"
                      strokeWidth="3.88235"
                    />
                    <path
                      d="M33.6317 36.3769C34.392 37.1327 35.6211 37.1291 36.3769 36.3688C37.1327 35.6085 37.1291 34.3794 36.3688 33.6236L33.6317 36.3769ZM36.3688 33.6236L29.144 26.4412L26.4068 29.1945L33.6317 36.3769L36.3688 33.6236Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
                <span className="b-search-form__line" />
              </form>
              </div>
            </div>
          </div>
        </section>
        <>
          <section className="inner_static">
            <div className="container">
              <div className="row">
                <div className="page_content_static ticket_container help_container_articles">
                  <div className="left_menu_ticket_accordin">
                    <div className="left_nav_bar_main">
                      <div className="accordion" id="accordionExample">
                      {helpData?.mainCategories?.length > 0 && helpData.mainCategories.map((mainCategory, index) => (
                        <div className="accordion-item" key={mainCategory.id}>
                          <h2 className="accordion-header" id={`heading${index}`}>
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse${index}`}
                              aria-expanded="false"
                              aria-controls={`collapse${index}`}
                            >
                              {mainCategory.title}
                            </button>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`heading${index}`}
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <ul>
                                {helpData.parentCategories
                                  ?.filter(parent => parent['main-category-id'] === mainCategory.id)
                                  .map(parent => (
                                    <li key={parent.id}>
                                      <a href={`#${parent.title.replace(/\s+/g, '-').toLowerCase()}`}>
                                        {parent.title}
                                      </a>
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    </div>
                  </div>
                  <div className="right_block_ticket help_block_right_main">
                    <div className="b-help-item">
                      <h3 className="ticket_headings lg-font_size">Looking for help? </h3>
                      <div className="small_heading">
                        Explore our Help Center and Community Guidelines below.
                      </div>
                      <div className="img_help_first_block">
                        <img src={looking_help} alt="" />
                      </div>
                    </div> 

                    {filteredHelpData?.mainCategories?.length > 0 ? (
                      filteredHelpData.mainCategories.map(mainCategory => (
                        <div className="b-help-item" key={mainCategory.id}>
                          <h3 className="ticket_headings lg-font_size">{mainCategory.title}</h3>
                          {filteredHelpData.parentCategories
                            ?.filter(parent => parent['main-category-id'] === mainCategory.id)
                            .map(parent => (
                              <div className="b_help_article" key={parent.id}>
                                <h6 id={parent.title.replace(/\s+/g, '-').toLowerCase()}>{parent.title}</h6>
                                <ul>
                                  {filteredHelpData.childCategories
                                    ?.filter(child => child['parent-category-id'] === parent.id)
                                    .map(child => (
                                      <li key={child.id}>
                                        <Link to={`/help/${mainCategory.id}/${parent.id}/${child.id}`}>
                                          {child.title}
                                        </Link>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            ))}
                        </div>
                      ))
                    ) : (
                      <div className="no-results">
                        <h4>No results found</h4>
                        <p>Try searching for different keywords or check the categories.</p>
                      </div>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </section>
        </>

      <Footer />
    </div>
  );
};

export default Help;
